import { Link, Navigate } from 'react-router-dom'

import { useAuth } from '@/lib/auth/auth-context'
import { canAddCompanies } from '@/lib/auth/roles'

import { useCompanies } from './use-companies'

export function CompanyIndex() {
  const { session } = useAuth()
  const companies = useCompanies()

  if (companies.isPending) {
    return (
      <div className="canopy-page">
        <div className="canopy-page-header">
          <div>
            <h1 className="canopy-page-title">Company view</h1>
            <div className="canopy-page-sub">Loading…</div>
          </div>
        </div>
      </div>
    )
  }

  if (companies.isError) {
    return (
      <div className="canopy-page">
        <div className="canopy-page-header">
          <div>
            <h1 className="canopy-page-title">Company view</h1>
            <div className="canopy-page-sub" role="alert" style={{ color: 'var(--red-600)' }}>
              Could not load the company list.
            </div>
          </div>
        </div>
      </div>
    )
  }

  const first = [...companies.data].sort((a, b) => a.name.localeCompare(b.name))[0]

  if (!first) {
    const mayAdd = canAddCompanies(session?.role ?? null)

    return (
      <div className="canopy-page">
        <div className="canopy-page-header">
          <div>
            <h1 className="canopy-page-title">Company view</h1>
            <div className="canopy-page-sub">No companies yet.</div>
          </div>
        </div>
        <div className="canopy-card" style={{ textAlign: 'center', padding: '40px 20px' }}>
          <div style={{ fontSize: 14, color: 'var(--text-2)', marginBottom: 12 }}>
            {mayAdd
              ? 'There is nothing to open a scorecard for yet.'
              : 'You do not have access to any company yet.'}
          </div>
          {mayAdd ? (
            <Link to="/admin/companies" className="canopy-btn canopy-btn-primary">
              Add companies →
            </Link>
          ) : (
            <div style={{ fontSize: 13, color: 'var(--text-3)', lineHeight: 1.5 }}>
              Company access is the growth team&rsquo;s to grant. Ask them to add you to a company,
              and its scorecard will open here.
            </div>
          )}
        </div>
      </div>
    )
  }

  return <Navigate to={`/company/${encodeURIComponent(first.id)}`} replace />
}
